import { render, staticRenderFns } from "./EquiposList.vue?vue&type=template&id=4b0dc8d6"
import script from "./EquiposList.vue?vue&type=script&setup=true&lang=js"
export * from "./EquiposList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports